import React from 'react';
import Registration from './Registration';
import Login from './Login';
import Dashboard from './Dashboard';
import NavBar from './NavBar';
import HeartRate from './HeartRate';
import Pressures from './Pressures';
import { Switch, Route, Redirect } from 'react-router-dom'


class Main extends React.Component {
  render() {
    if (window.location.pathname === "/") {
      return <Redirect to="/login" />;
    }

    return (
      <main>
        {!window.location.href.includes('login') && !window.location.href.includes('registration') ? <NavBar /> : null}

        <Switch>
          <Route exact path='/login' component={Login} />
          <Route exact path='/registration' component={Registration} />
          <Route path='/dashboard' component={Dashboard} />
          <Route path='/HeartRate' component={HeartRate} />
          <Route path='/pressures' component={Pressures} />
        </Switch>
      </main>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/Main.js